module.exports = __webpack_public_path__ + "static/media/ava_3vi_main.334a08b5.png";